import * as React from 'react';

export interface DelayedRenderOpts {
    delay?: number
    children?: React.ReactElement | React.ReactElement[]
}

const DelayedRender: React.FC<DelayedRenderOpts> = ({
    delay = 0,
    children
}: DelayedRenderOpts): React.ReactElement => {
    const [show, setShow] = React.useState(false);

    React.useEffect(() => {
        const timeoutHandle = setTimeout(() => setShow(true), delay);
        return () => clearTimeout(timeoutHandle);
    }, []);

    if (show === false) {
        return null;
    }
    return <>{children}</>;
};

export default DelayedRender;
